<div class="map-toolbar-vertical">
  @for (btn of toolbarButtons(); track $index) {
    <button
      class="toolbar-btn"
      matBadgeColor="accent"
      [matBadge]="
        btn.icon === 'eval' ? '!' : btn.icon === 'pets' ? selectedCompareKeys().length : '1'
      "
      matBadgePosition="before"
      [matBadgeHidden]="
        btn.icon === 'filter_alt'
          ? !isFilterActive()
          : btn.icon === 'eval'
            ? !evalActive()
            : btn.icon === 'pets'
              ? !selectedCompareKeys().length
              : true
      "
      [class.active]="isButtonActive($index, btn)"
      [disabled]="btn.disabled"
      [matTooltip]="btn.label"
      [matTooltipPosition]="'left'"
      [id]="btn.id"
      (click)="onButtonClick($index, btn)"
    >
      @if (btn.icon === 'eval') {
        <span class="toolbar-btn__text" [class.active]="isButtonActive($index, btn)">Eval</span>
      } @else {
        <mat-icon [color]="isButtonActive($index, btn) ? 'accent' : ''">
          <span class="material-icons-outlined">
            {{ btn.icon }}
          </span></mat-icon
        >
      }
    </button>
    <!-- currently its loaded on initialization and just toggle on hidden. -->
    <!-- TODO- apply filters direclty to map using preferences or local state and avoid hidden  -->
    @if (
      (openPanelIndex === $index &&
        (btn.panelComponent || btn.icon === 'info' || btn.icon === 'pets')) ||
      btn.panelComponent === FiltersComponent
    ) {
      <div
        [hidden]="btn.panelComponent === FiltersComponent && openPanelIndex !== $index"
        [style.top.px]="openPanelIndex * 42"
        [class.toolbar-panel-left-overlay]="
          btn.panelComponent === FiltersComponent ||
          btn.panelComponent === LayersPanelComponent ||
          btn.icon === 'info' ||
          btn.icon === 'pets'
        "
        [class.info-panel-overlay]="btn.icon === 'info'"
        [ngStyle]="{
          width:
            btn.panelComponent === FiltersComponent
              ? '225px'
              : btn.icon === 'info'
                ? '250px'
                : layersPanelWidth(),
        }"
      >
        @if (btn.icon === 'info') {
          <div
            class="map-toolbar-info-content"
            tabindex="0"
            role="button"
            (click)="onInfoClick($event)"
            (keydown.enter)="onInfoClick($event)"
            (keydown.space)="onInfoClick($event); $event.preventDefault()"
          >
            <p [innerHTML]="infoText()"></p>
          </div>
        }
        @if (btn.icon === 'pets') {
          <div class="toolbar-panel-placeholder">
            <vectronic-card
              subTitle="Nearby Animals"
              [displayClose]="true"
              [closeIcon]="'close'"
              (closed)="closePanel()"
            >
              <ng-container body>
                <div class="compare-collars-panel">
                  @if (compareOptions().length === 0) {
                    <div class="compare-collars-empty">No nearby animals in view.</div>
                  } @else {
                    @for (option of compareOptions(); track option.key) {
                      <label
                        class="compare-collar-row"
                        [matTooltip]="option.tooltip"
                        [matTooltipDisabled]="!option.tooltip"
                        matTooltipPosition="left"
                      >
                        <input
                          type="checkbox"
                          [checked]="selectedCompareKeys().includes(option.key)"
                          (change)="onCompareOptionToggle(option.key, $event)"
                        />
                        <span class="compare-collar-dot" [style.background]="option.color"></span>
                        <span class="compare-collar-label">{{ option.label }}</span>
                      </label>
                    }
                  }
                </div>
              </ng-container>
            </vectronic-card>
          </div>
        }
        @if (btn.panelComponent === FiltersComponent) {
          <div class="toolbar-panel-placeholder">
            <vectronic-card
              title="Filters"
              [displayClose]="true"
              [closeIcon]="'close'"
              (closed)="closePanel()"
            >
              <ng-container body>
                <div class="px-12" [hidden]="!isVirtualFenceEnabled()">
                  <vectronic-filter-header
                    (enabledFilterToggle)="virtualFenceFilterToggle($event)"
                    title="Selection"
                    [isFilterEnabled]="true"
                    [icon]="'filter_alt'"
                  ></vectronic-filter-header>
                  @if (virtualFenceFilterToggled()) {
                    <div class="collar-container">
                      @for (collar of selectedCollarsFilterList(); track $index) {
                        <div class="d-flex justify-content-between align-items-center">
                          <mat-checkbox
                            [checked]="collar.checked"
                            (change)="
                              onCollarIdChange({
                                checked: $event.checked,
                                collar: collar,
                              })
                            "
                            >{{ collar.id }}
                          </mat-checkbox>

                          <mat-icon
                            (click)="virtualFenceZoomToCollar.emit({ collarId: collar.id })"
                            color="accent"
                            class="mr-6"
                            >gps_fixed
                          </mat-icon>
                        </div>
                      }
                    </div>
                  }
                </div>
                <vectronic-filters
                  [isDashboardPage]="isDashboardPage()"
                  [userPreferences]="userPreferences()"
                  [filtersToDisplay]="filtersToDisplay()"
                  [pageName]="pageName()"
                  [initialLastXRecordsValue]="initialLastXRecordsValue()"
                  (filterValuesSaved)="onFilterValuesSaved($event)"
                ></vectronic-filters>
              </ng-container>
            </vectronic-card>
          </div>
        }
        @if (btn.panelComponent === LayersPanelComponent) {
          <div class="toolbar-panel-placeholder">
            <vectronic-card
              [subTitle]="featureLayerDetails.selectedKey() ? 'Properties' : 'Layers'"
              [displayClose]="true"
              [closeIcon]="featureLayerDetails.selectedKey() ? 'arrow_back' : 'close'"
              (closed)="onLayersCardClosed()"
            >
              <ng-container body>
                <!-- Feature layer details slide in inside the same card: the
                     list slides out left while the details take its place,
                     and the details' back arrow slides back to the list. -->
                <div class="layers-panel-slider">
                  <div
                    class="layers-panel-track"
                    [class.show-details]="featureLayerDetails.selectedKey()"
                  >
                    <div class="layers-panel-view">
                      <bm-layers-panel></bm-layers-panel>
                    </div>
                    <div class="layers-panel-view">
                      @if (featureLayerDetails.selectedKey(); as detailsKey) {
                        <bm-feature-layer-details-panel
                          [layerKey]="detailsKey"
                        ></bm-feature-layer-details-panel>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </vectronic-card>
          </div>
        }
      </div>
    }
  }
</div>
